export { default } from "./MonolithContentCard";
